import { useSession } from '../../components/Session';
import { useAPI } from './useAPI';
export const useAuthAPI = (endpoint, options) => {
  const [{
    token
  }] = useSession();
  return useAPI(endpoint, {
    method: "POST",
    ...options,
    headers: {
      "Authorization": `Bearer ${token}`,
      ...options?.headers
    }
  });
};